import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
export default function SharedBanner(_ref) {
  var isMobileOnly = _ref.isMobileOnly,
    children = _ref.children,
    animation = _ref.animation,
    dataTestId = _ref.dataTestId,
    isVisibile = _ref.isVisibile;
  if (!isVisibile) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": dataTestId,
    className: "".concat(isMobileOnly ? styles['mobile-only'] : '', " ").concat(styles.banner, " ").concat(styles[animation], "\n      ").concat(isMobileOnly ? styles['banner--filtered-banner'] : styles['banner--style-match-banner'], "\n      ")
  }, children);
}
SharedBanner.defaultProps = {
  isMobileOnly: false
};
process.env.NODE_ENV !== "production" ? SharedBanner.propTypes = {
  isMobileOnly: PropTypes.bool,
  children: PropTypes.node.isRequired,
  animation: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isVisibile: PropTypes.bool.isRequired
} : void 0;